import { z } from 'zod'

import type { ZodInfer } from '@mntn-dev/utility-types'

import { ModelFilterSchema } from '../model-filter-schema.ts'
import {
  SurveyDetailsSchema,
  SurveySubjectIdSchema,
  SurveyTypeSchema,
} from './survey-details/index.ts'
import { SurveyIdSchema, UserIdSchema } from './unique-id.models.ts'

/**
 * SurveyDomainSelectModel
 */
export const SurveyDomainSelectModelSchema = z.object({
  surveyId: SurveyIdSchema,
  responderId: UserIdSchema,
  details: SurveyDetailsSchema,
})

export type SurveyDomainSelectModel = ZodInfer<
  typeof SurveyDomainSelectModelSchema
>

/**
 * SurveyDomainInsertModel
 */
export const SurveyDomainInsertModelSchema =
  SurveyDomainSelectModelSchema.partial({ surveyId: true })

export type SurveyDomainInsertModel = ZodInfer<
  typeof SurveyDomainInsertModelSchema
>

/**
 * SurveyDomainUpdateModel
 */
export const SurveyDomainUpdateModelSchema = z.never()

export type SurveyDomainUpdateModel = ZodInfer<
  typeof SurveyDomainUpdateModelSchema
>

/**
 * SurveyDomainSelectModelFilters
 */
export const SurveyDomainSelectModelFiltersSchema = z
  .object({
    surveyId: ModelFilterSchema(SurveyIdSchema),
    surveyType: ModelFilterSchema(SurveyTypeSchema),
    responderId: ModelFilterSchema(UserIdSchema),
    subjectId: ModelFilterSchema(SurveySubjectIdSchema),
  })
  .partial()

export type SurveyDomainSelectModelFilters = ZodInfer<
  typeof SurveyDomainSelectModelFiltersSchema
>

export * from './survey-details/index.ts'
